/* eslint-disable */
export default {
  forward: '転送',
  ignore: '無視',
  toVoicemail: 'ボイスメールへ',
  answer: '応答',
  endAndAnswer: '終了＆応答',
  holdAndAnswer: '保留して応答',
  custom: 'カスタム',
  more: '詳細',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"ignore"@#@ @source: @#@"Ignore"@#@
// @key: @#@"toVoicemail"@#@ @source: @#@"To Voicemail"@#@
// @key: @#@"answer"@#@ @source: @#@"Answer"@#@
// @key: @#@"endAndAnswer"@#@ @source: @#@"End & Answer"@#@
// @key: @#@"holdAndAnswer"@#@ @source: @#@"Hold & Answer"@#@
// @key: @#@"custom"@#@ @source: @#@"Custom"@#@
// @key: @#@"more"@#@ @source: @#@"More"@#@
